var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Profile_Icon_M_",
    "data-name": "Profile Icon (M)",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 22,
    height: 22,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M125.558,81.79a4.065,4.065,0,1,1-4.065-4.065,4.065,4.065,0,0,1,4.065,4.065",
    transform: "translate(-110.493 -72.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M66.575,297.981a11.241,11.241,0,0,0-7.583,2.928,10.536,10.536,0,0,0,15.165,0,11.241,11.241,0,0,0-7.583-2.928",
    transform: "translate(-55.575 -282.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    transform: "translate(0.141 0.141)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.927,
    cy: 10.927,
    r: 10.927,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.927,
    cy: 10.927,
    r: 9.927,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/ProfileIcon.90ad22f8abebdbd6ced1d7fe6397e1a2.svg";
export { ForwardRef as ReactComponent };